import { useEffect, useState } from "react";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { onGetOrgDept } from "../services/department";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { useParams } from "react-router-dom";

export default () => {
  const [selectedOrgDepts, setselectedOrgDepts] = useState<any[]>([]);
  const { SelectedOrg, config } = useStateGetter();
  const { setLoading } = useStateSetter();
    const {orgid}=useParams()
  
  const getOrgDepartments = async () => {
    setLoading(true);
    try {
      var response = await onGetOrgDept(SelectedOrg.id??orgid, config);

      setselectedOrgDepts(response.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    getOrgDepartments();
  }, []);

  return { selectedOrgDepts };
};
